import { ProcessoComponent } from './processo/processo.component';
import { ViolenciaGeneroComponent } from './violencia-genero/violencia-genero.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FILE_UPLOADER } from 'src/app/componentes/file-uploader/file-uploader.component';
import { AuthService } from 'src/app/service/autenticacao/auth.service';
import { ReclamacaoService } from 'src/app/service/reclamacao/reclamacao.service';
import { PAGINA_SUCESSO_FORM } from 'src/app/tools/URL';
import {
  ERRO_DADOS_NAO_GRAVADOS, MSG_LIMITE_DESCRICAO, MSG_OBG_ASSUNTO, MSG_OBG_CARTORIO, MSG_OBG_CLASSIFICACAO,
  MSG_OBG_DESCRICAO, MSG_OBG_MUNICIPIO, MSG_OBG_TIPO_JUSTICA, OK_MANIFESTO_ENVIADO, MSG_OBG_NUM_PROCESSO, MSG_OBG_NUM_PROCESSO_VALIDO, MSG_OBG_TIPO_JUSTICA_OPCAO, MSG_OBG_TIPO_JUSTICA_OPCAO_ANEXO
} from './../../../tools/Mensagens';

@Component({
  selector: 'reclamacao',
  templateUrl: './reclamacao.component.html',
  styleUrls: ['./reclamacao.component.css']
})
export class ReclamacaoComponent implements OnInit {
  nome = this.authService.usuarioDTO.nome;
  email = this.authService.usuarioDTO.email;
  @ViewChild(FILE_UPLOADER, { static: false }) fileUploader;
  @ViewChild(ProcessoComponent, { static: false }) processo: ProcessoComponent;
  @ViewChild(ViolenciaGeneroComponent, { static: false }) violenciaGenero: ViolenciaGeneroComponent;

  alerts: string;

  CLASSIFICACAO_SERVIDOR_INTERIOR = 39;


  constructor(
    public service: ReclamacaoService,
    private router: Router,
    public authService: AuthService) { }

  ngOnInit() {
    this.service.carregarDados();
    this.service.reclamacao.controls.nome.setValue(this.authService.usuarioDTO.nome);
    this.service.reclamacao.controls.email.setValue(this.authService.usuarioDTO.email);
    this.checarAssuntoUnico();

  }

  checarAssuntoUnico() {
    if (this.service.reclamacao.controls.assuntos.value != null && this.service.reclamacao.controls.assuntos.value.length == 1) {
      this.changeAssunto(this.service.reclamacao.controls.assuntos.value[0]);
    }
  }

  onSubmit() {

    this.validarFormulario();

    if (this.service.reclamacao.value.assunto) {

      this.preencherDadosReclamacao();

      this.validarRegrasPrimeiraInstância();

      //TODO Verificar esta situação, que é realizado o preenchimento do cartorio (OS 1285)
      if(this.service.reclamacao.controls.cartorio) {

        const cartorio = this.service.reclamacao.value.listaCartorio
        .find(cartorio => cartorio.nomeServico === this.service.reclamacao.controls.cartorio.value && cartorio.id.municipio.nome === this.service.reclamacao.controls.municipio.value);
        this.service.reclamacao.value.cartorio = cartorio;

      }

      if (this.alerts.length === 0) {
        this.service.enviar(this.service.reclamacao.value).subscribe(retorno => {
          if (retorno) {
            alert(OK_MANIFESTO_ENVIADO);
            //console.log('PAGINA_SUCESSO_FORM');
            this.router.navigate([PAGINA_SUCESSO_FORM]);
          } else {
            //console.log('ERRO_DADOS_NAO_GRAVADOS');
            alert(ERRO_DADOS_NAO_GRAVADOS);
          }
        });
      }
    }
  }

  // Método que valida as regras, caso seja selecionado o tipo de justiça 1ª Instância. (OS 860)
  // Observação: Necessitou ficar separada das outras validações de campos pois era necessário o popular da lista de documentos
  // que só seria feito depois de executar o validarFormulario
  validarRegrasPrimeiraInstância() {

    if(this.alerts.length === 0){
      if (this.service.reclamacao.value.tipoDeJustica === '1') {
        if (this.service.reclamacao.value.opcaoTipoDeJustica == '2'
          && (this.service.reclamacao.value.filesCunhoDisciplinar == null
            || this.service.reclamacao.value.filesCunhoDisciplinar.length === 0)) {
              this.alerts = this.alerts + MSG_OBG_TIPO_JUSTICA_OPCAO_ANEXO;
        }
      }

      if (this.alerts.length > 0) {
        alert(this.alerts);
      }
    }
  }

  preencherDadosReclamacao() {

    this.service.reclamacao.value.nome = this.authService.usuarioDTO.nome;
    this.service.reclamacao.value.email = this.authService.usuarioDTO.email;

    if (this.service.reclamacao.value.tipoDeJustica === '1' || this.service.reclamacao.value.tipoDeJustica === '2') {
      this.service.reclamacao.value.tipoDeJustica = this.service.reclamacao.value.tipoDeJustica;
    } else {
      this.service.reclamacao.value.tipoDeJustica = null;
    }

    // Forçando a atribuição da informação, já que a mesma esta se perdendo durante o processo.
    if(this.service.reclamacao.controls.codUnidade != null){
      this.service.reclamacao.controls.codUnidade.setValue(this.service.reclamacao.controls.codUnidade.value);
    }

    if(this.service.reclamacao.controls.siglaUnidade != null){
      this.service.reclamacao.controls.siglaUnidade.setValue(this.service.reclamacao.controls.siglaUnidade.value);
    }

    this.service.reclamacao.value.files = [];
    this.service.reclamacao.value.filesCunhoDisciplinar = [];
    this.fileUploader.mapFilesBase64.forEach((value, key) => {
      //console.log('NomeArquivo: ', key );
      this.service.reclamacao.value.files.push({
        nomeArquivo: key,
        conteudo: value
      });
    });

    // Caso tenha arquivos anexados de processos judiciais, serão incorporados a lista de arquivos com uma tag para ser
    // tratado como um documento diferente dos documentos de anexo padrão, e receber a tipagem correta ao enviar para o SEI. (OS 860)
    if(this.processo !== undefined && this.processo.arquivosAnexados != null){

      this.processo.arquivosAnexados.mapFilesBase64.forEach((value, key) => {
        //console.log('NomeArquivo Anexado + (RGCE): ', nomeArquivoComTag);
        //var nomeArquivoComTag = key;
        var nomeArquivoComTag = String(key).replace("."," (RGCE).");
        this.service.reclamacao.value.filesCunhoDisciplinar.push({
          nomeArquivo: nomeArquivoComTag,
          conteudo: value
        });
      });
    }
  }

  zeraListaClassificacao() {
    this.service.reclamacao.value.listaClassificacao = [];
  }

  desmarcarCheckOutrosAssuntos() {
    if (this.isAssuntoChecked('reclamacao_admin_violencia_genero')) {
      this.service.reclamacao.controls.reclamacaoViolencia.reset();
      this.service.reclamacao.controls.reclamacaoViolencia.get('tipos').setValue([]);
      this.service.reclamacao.controls.reclamacaoViolencia.get('provas').setValue([]);
    }
    this.service.reclamacao.value.listaClassificacaoCompleta
      .map(item => item.selecionado = false);

    this.service.reclamacao.controls.tipoDeJustica.reset();
    this.service.reclamacao.controls.numeroProcesso.reset();
    this.service.reclamacao.controls.comarca.reset();
    this.service.reclamacao.controls.vara.reset();
    this.service.reclamacao.controls.numeroINFOPEN.reset();
    this.service.reclamacao.controls.descricaoReclamacao.setValue('');
    this.service.reclamacao.controls.municipio.reset();
    this.service.reclamacao.controls.cartorio.reset();
    this.service.reclamacao.controls.localidade.reset();
    this.service.reclamacao.controls.listaTipoProcesso.reset();
    this.service.reclamacao.controls.listaSistemas.reset();
    this.service.reclamacao.controls.listaClassificacao.setValue([]);
    this.service.reclamacao.controls.assunto.reset();
    this.service.reclamacao.controls.files.reset();
    this.service.reclamacao.controls.numeroProcesso.disable();

  }

  changeAssunto(item) {
    this.service.reclamacao.controls.assunto.setValue(item);

    this.service.reclamacao.value.listaClassificacaoCompleta
      .map(item => item.selecionado = false);

    this.service.reclamacao.value.assuntos
      .filter(assunto => assunto.id === item.id)
      .forEach((assunto: any) => assunto.selected = true);

    this.service.reclamacao.value.assuntos
      .filter(assunto => assunto.id !== item.id)
      .forEach((assunto: any) => assunto.selected = false);

    this.resetFormControl();
  }

  resetFormControl() {
    this.service.reclamacao.controls.tipoDeJustica.reset();
    this.service.reclamacao.controls.localidade.reset();
    this.service.reclamacao.controls.descricaoReclamacao.setValue('');
  }

  isAssuntoChecked(str) {
    return this.service.reclamacao.value.assunto &&
      this.service.reclamacao.value.assuntos
        .filter((assunto: any) => assunto.selected && assunto.value === str)
        .length > 0 ? true : false;
  }

  isReclamacaoTipoDeJusticaPrimeiraInstancia() {
    if (this.service.reclamacao.value.assunto.value === 'reclamacao_processo'
      && this.service.reclamacao.value.tipoDeJustica != null
      && this.service.reclamacao.value.tipoDeJustica === '1') {

        return true;
    }

    return false;
  }

  validarFormulario() {
    this.alerts = '';

    if (this.service.reclamacao.value.assunto == null || this.service.reclamacao.value.assunto === '') {
      this.alerts = this.alerts + MSG_OBG_ASSUNTO;
    } else {
      // Validação de classificações não deverá ser feita caso seja Processos Judiciais de 1ª Instância
      if (!this.isAssuntoChecked('reclamacao_admin_violencia_genero')
        && !this.isReclamacaoTipoDeJusticaPrimeiraInstancia()
        && this.service.reclamacao.value.listaClassificacao.length === 0) {
        this.alerts = this.alerts + MSG_OBG_CLASSIFICACAO;
      }

      // Substituição dos campos de municio e cartorio (OS 1285)
      if (this.service.reclamacao.value.codigoMunicipio === '' && this.service.reclamacao.value.assunto.value === 'reclamacao_cartorios') {
        this.alerts = this.alerts + MSG_OBG_MUNICIPIO;
        this.service.reclamacao.controls['codigoMunicipio'].setErrors({});
      }
      if (this.service.reclamacao.value.codigoCNS === '') {
        this.service.reclamacao.controls['codigoCNS'].setErrors({});
        this.alerts = this.alerts + MSG_OBG_CARTORIO;
      }

      if (this.service.reclamacao.value.descricaoReclamacao === ''
        || this.service.reclamacao.value.descricaoReclamacao == null) {
        this.alerts = this.alerts + MSG_OBG_DESCRICAO;
      } else if (this.service.reclamacao.value.descricaoReclamacao.length > 5000) {
        this.alerts = this.alerts + MSG_LIMITE_DESCRICAO;
      }
      if (this.isAssuntoChecked('reclamacao_admin_violencia_genero') && this.violenciaGenero) {
        this.alerts += this.violenciaGenero.validar();
      }
      if (this.service.reclamacao.value.assunto.value === 'reclamacao_processo') {
        // Tratamento para as opções do tipo de justiça quando for 1ª Instância
        if (this.service.reclamacao.value.tipoDeJustica === ''
          || this.service.reclamacao.value.tipoDeJustica == null) {
          this.alerts = this.alerts + MSG_OBG_TIPO_JUSTICA;
          this.service.reclamacao.controls['tipoDeJustica'].setErrors({});

        } else if (this.service.reclamacao.value.tipoDeJustica === '1') {
          if (this.service.reclamacao.value.opcaoTipoDeJustica === null) {
            this.service.reclamacao.controls['opcaoTipoDeJustica'].setErrors({});
            this.alerts = this.alerts + MSG_OBG_TIPO_JUSTICA_OPCAO;
          }
        }
        // Regras dos campos do processo
        if (this.service.reclamacao.value.numeroProcesso === '') {

          this.service.reclamacao.controls['numeroProcesso'].setErrors({});
          this.alerts = this.alerts + MSG_OBG_NUM_PROCESSO;
        } else if (this.service.reclamacao.controls.comarca.value === '' || this.service.reclamacao.controls.comarca.value === null) {
          this.service.reclamacao.controls['comarca'].setErrors({});
          this.alerts = this.alerts + MSG_OBG_NUM_PROCESSO_VALIDO;
        } else if (this.service.reclamacao.controls.vara.value === '' || this.service.reclamacao.controls.vara.value === null) {
          this.service.reclamacao.controls['vara'].setErrors({});
          this.alerts = this.alerts + MSG_OBG_NUM_PROCESSO_VALIDO;
        }
      }
    }
    if (this.alerts.length > 0) {
      alert(this.alerts);
    }
  }
}
